import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="column-wide, colums"><path d="M11.25 4H5.75C3.67893 4 2 5.67893 2 7.75V16.25C2 18.3211 3.67893 20 5.75 20H11.25V4Z" fill="currentColor"/><path d="M12.75 20H18.25C20.3211 20 22 18.3211 22 16.25V7.75C22 5.67893 20.3211 4 18.25 4H12.75V20Z" fill="currentColor"/></CentralIconBase>;
};

export default IconColumnWide;
